export const firebaseConfig = {
  apiKey: 'AIzaSyBtk6ooR__0fFSsCIjzezlfVGkqoHhWjYg',
  authDomain: 'formulando.firebaseapp.com',
  databaseURL: 'https://formulando-default-rtdb.firebaseio.com',
  projectId: 'formulando',
  storageBucket: 'formulando.appspot.com',
  messagingSenderId: '27682882559',
  appId: '1:27682882559:web:fb3af65ef8fd599866ddca',
  measurementId: 'G-HJXZKFKLES',
};
